import React from 'react';
import { FacilityScheduleTemplate } from 'themes/application/facility/pages';
import { observer } from 'mobx-react';
import { FacilityScheduleViewStore } from 'application/facility/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore) => new FacilityScheduleViewStore(rootStore), 'editView')
@observer
class FacilitySchedule extends React.Component {
    render() {
        return <FacilityScheduleTemplate {...this.props} />
    }
}

export default FacilitySchedule;